import React from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import RFQProposalSidebar from 'components/common/rfq/RFQProposalSidebar';
import RFQProposalPageContent from 'components/rfq/quote/proposal-rfq/RFQProposalPageContent';
import RFQProposalPageFooter from 'components/rfq/quote/proposal-rfq/RFQProposalPageFooter';
import RFQProposalPageHeader from 'components/rfq/quote/proposal-rfq/RFQProposalPageHeader';
import { createStyles } from './styles';

const RFQProposalPage: React.FC = () => {
  const classes = createStyles();

  return (
    <GlobalLayout
      leftSection={<RFQProposalSidebar />}
      rightSection={
        <div className={classes.proposalContent}>
          <RFQProposalPageHeader />
          <RFQProposalPageContent />
          <RFQProposalPageFooter />
        </div>
      }
    />
  );
};

export default RFQProposalPage;
